import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';

@Component({
    selector: 'app-help-modal',
    standalone: true,
    imports: [ModalComponent],
    templateUrl: './help-modal.component.html',
    styleUrls: ['./help-modal.component.css']
})
export class HelpModalComponent {
    @Input() isOpen: boolean = false;
    @Output() close = new EventEmitter<void>();

    onClose(): void {
        this.close.emit();
    }
}
